export default __webpack_public_path__ + "static/media/p4.9694833a.png";